<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
          <public-restaurant :restaurant="restaurant" v-if="canRestaurant" ></public-restaurant>
      </div>
    </div>
  </div>

</template>

<script>
  import PublicRestaurant from '../components/Restaurants/PublicRestaurant';
  import {mapActions, mapGetters} from 'vuex';

  export default {
    components: {
      PublicRestaurant
    },
    data () {
      return {
      }
    },
    created () {
        this.getRestaurantPublic({slug: this.$route.params.slug, language: this.language});
    },
    computed: {
      ...mapGetters({
        restaurant: 'getRestaurant',
        language: 'getCurrentLanguagePublic'
      }),
      canRestaurant () {
        return Object.keys(this.restaurant).length;
      }
    },
    methods: {
      ...mapActions({
        getRestaurantPublic: 'getRestaurantPublic',
      })
    }

  }

</script>

<style>

</style>
